import React from "react";
import { useSettings } from "./useSettings";

// Create a wrapper that uses the settings context
export const useTheme = () => {
  const { settings, toggleTheme } = useSettings();

  return {
    theme: settings.theme,
    toggleTheme,
  };
};

// Theme provider is now handled by SettingsProvider
// Theme is applied directly in useSettings for immediate application
export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  // Theme application is now handled by useSettings hook for better performance
  return <>{children}</>;
};
